








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class StatusIcon extends Vue {
  @Prop({ required: true })
  type: 'success' | 'error' | 'cancel'

  get iconClass(): string {
    switch (this.type) {
      case 'success':
        return 'fa-check-circle'
      case 'cancel':
        return 'fa-ban'
      default:
        return 'fa-times-circle'
    }
  }
}
